// Copyright (c) 2017 Comsearch, Inc., All rights reserved

// instead of creating custom formatters for these cells,
// just put the values of interest at the top level of the object.

const hasServiceContactCode = contactCode => (
  contactCode !== null &&
  contactCode !== undefined &&
  String(contactCode).trim() !== ''
)

const prepData = arr => (
  arr.reduce((a, d) => {
    // General contacts have no service contact code and are excluded from lookup.
    if (hasServiceContactCode(d.contactCode)) {
      a.push(d)
    }
    return a
  }, []).map(d => {
    // TODO - remove the below once API returns string values instead of bool.
    d.status = typeof d.status === 'string' ? d.status : (d.status ? 'Active' : 'Invalid')
    d.uniqueId = 'contactId'
    return d
  })
)

export default prepData
